import React from 'react';
import { Drawer } from '../shared/Drawer';
import { Button, Spinner } from 'flowbite-react';
import { useMediaQuery } from '@mui/material';
import { useMutation } from 'react-query';
import { lockRoundTemplateByLabelId } from 'src/apis/round';
import { useToast } from 'src/context/ToastProvider';

const ShowTemplateLockModal = ({
	isOpen,
	onClose,
	onConfirm,
	isLoading,
	templateLabel,
	isAIRoundSelected,
	selectedRoundTemplate,
}: {
	isOpen: boolean;
	isLoading: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isAIRoundSelected: boolean;
	templateLabel?: string | null;
	selectedRoundTemplate?: string | null;
}) => {
	const toast = useToast();
	const isMobile = useMediaQuery('(max-width:960px)');

	const lockRoundTemplateByLabelIdFn = useMutation(['lockRoundTemplateByLabelId'], lockRoundTemplateByLabelId, {
		onSuccess(data) {
			console.log('data:', data);
		},
		onError(err) {
			console.log('err:', err);
		},
	});

	return (
		<Drawer
			isModal={!isMobile}
			isOpen={isOpen}
			minHeight="fit-content"
			fullWidth={true}
			onClose={onClose}
			header={
				<h6 className="text-[#1C1C28] dark:text-white text-[20px] font-[700] px-[22px] pt-[20px] min-h-[36px]">
					Confirm Your Selection
				</h6>
			}
			body={
				<div className="px-[25px] pt-[8px] pb-[25px]">
					<p className="text-[16px] text-[#555770] dark:text-gray-300">
						You have chosen{' '}
						<strong className="text-[#1C1C28] dark:text-gray-200">{selectedRoundTemplate || 'N/A'}</strong>. Please
						confirm your preference. Note: Once confirmed, this selection cannot be changed.
					</p>

					<div className="mt-[32px] flex gap-[16px] justify-start items-center flex-wrap">
						<Button
							color="purplePlaced"
							disabled={isLoading}
							className="w-full md:w-fit"
							onClick={() => {
								console.log('templateLabel:', templateLabel);
								if (templateLabel) {
									lockRoundTemplateByLabelIdFn?.mutate({
										labelId: templateLabel,
										isAiInterview: isAIRoundSelected,
									});
									onConfirm();
								} else {
									toast({
										title: 'Please select a template',
										type: 'error',
									});
								}
							}}
						>
							{isLoading ? (
								<div className="absolute flex justify-center inset-0 rounded-[inherit] items-center w-full h-full backdrop-blur-md">
									<Spinner className="float-right" />
								</div>
							) : null}
							Confirm
						</Button>
						<Button color="light" className="w-full md:w-fit" onClick={onClose} disabled={isLoading}>
							Cancel
						</Button>
					</div>
				</div>
			}
		></Drawer>
	);
};

export default ShowTemplateLockModal;
